import { SET_NEW_STATE } from '../actions/actionTypes'
import filterBuilder from './filterBuilder'
import updateFiltersFromSelections from './updateFiltersFromSelections'

export default (filters, dispatch, state, parseUrl = false) => {

  const ambiencesList = []
  const awardsList = []
  const cuisinesList = []

  if ( filters['ambiences'] && filters['ambiences'].length ) {
    filters['ambiences'].map( item => {
      ambiencesList.push({
        name: item,
        active: false,
      })
    })
  }

  if ( filters['awards'] && filters['awards'].length ) {
    filters['awards'].map( item => {
      awardsList.push({
        name: item.name,
        value: item.value,
        active: false,
      })
    })
  }

  if ( filters['cuisines'] && filters['cuisines'].length ) {
    filters['cuisines'].map( item => {
      cuisinesList.push({
        name: item,
        active: false,
      })
    })
  }

  const newState = filterBuilder(state, {ambiencesList, awardsList, cuisinesList}, parseUrl)

  const newState2 = updateFiltersFromSelections(newState)

  dispatch({
    type: SET_NEW_STATE,
    payload: {
      state: newState2,
    },
  })

}